._StickyHeader_1d0vu_1 {
  background: white;
  box-shadow: 0 32px 10px -10px rgb(255 255 255 / 80%);
  padding: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 1;
}
